"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _useControllableState = _interopRequireDefault(require("@ux/component-utilities/lib/use-controllable-state"));
var _id2 = _interopRequireDefault(require("@ux/component-utilities/lib/id"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ripOut = _interopRequireDefault(require("rip-out"));
const _excluded = ["onChange", "defaultChecked", "onKeyDown", "checked", "tabIndex", "hideLabel", "label"],
  _excluded2 = ["type"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * The different types of input that are allowed as toggle types.
 *
 * @type {Array}
 * @private
 */
const allowedTypes = ['checkbox', 'radio'];

/**
 * 2-state Switch.
 *
 * @param {Object} props Component props.
 * @param {Object} ref The forwardRef for the Toggle.
 * @returns {React.Component} The Toggle Component
 * @public
 */
const Toggle = /*#__PURE__*/_react.default.forwardRef(function Toggler(_ref, ref) {
  let {
      onChange: onControllableChange = Function.prototype,
      defaultChecked: defaultProp = false,
      onKeyDown = Function.prototype,
      checked: controllableProp,
      tabIndex = 0,
      hideLabel,
      label
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  let {
      type
    } = rest,
    props = (0, _objectWithoutProperties2.default)(rest, _excluded2);
  const id = (0, _id2.default)('label', {
    props: _objectSpread(_objectSpread({}, props), {}, {
      label
    })
  });
  const className = (0, _classnames.default)((0, _classnames.default)('ux-toggle', {
    'disabled': props.disabled,
    'ux-toggle-small': props.small
  }));
  const [checked, onChange] = (0, _useControllableState.default)({
    onChange: onControllableChange,
    prop: controllableProp,
    defaultProp
  });
  const _onChange = (0, _react.useCallback)(event => onChange(event.target.checked, {
    event
  }), [onChange]);
  const _onKeyDown = (0, _react.useCallback)(function useKeyDown(event) {
    event.preventDefault();
    onKeyDown(event);
    if ([' ', 'Enter'].includes(event.key)) {
      event.stopPropagation();
      onChange(!event.target.checked, {
        event
      });
    }
  }, [onChange, onKeyDown]);
  props = (0, _ripOut.default)(props, 'small', 'onChange', 'onKeyDown');
  type = allowedTypes.includes(type) ? type : allowedTypes[0];
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: className
  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, props, {
    type: type,
    tabIndex: tabIndex,
    checked: !!checked,
    className: 'ux-toggle-checkbox',
    onChange: _onChange,
    onKeyDown: _onKeyDown,
    id: id,
    ref: ref
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "ux-toggle-container"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ux-toggle-bg"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "ux-toggle-handle"
  })), !hideLabel && label && /*#__PURE__*/_react.default.createElement("span", {
    className: "ux-toggle-message"
  }, label));
});

/**
 * Validate label and require ID if label is a ReactElement
 *
 * @param {Object} props the props passed in
 * @param {string} propName the name of the current prop
 * @param {string} componentName the name of the component
 * @returns {Error | void} returns an error if label is invalid
 */
function validatePropTypeLabel(props, propName, componentName) {
  const label = props[propName];
  if (typeof label !== 'string' && !props.id) {
    return new Error(`Invalid prop "${propName}" supplied to "${componentName}". Prop "${propName}" must be a string, otherwise prop "id" must be provided. Validation failed`);
  }
}
Toggle.propTypes = {
  /** Defines the type of behavior for the toggle*/
  type: _propTypes.default.oneOf(allowedTypes),
  /** Identifies the toggle label on the page (used for aria references)*/
  htmlFor: _propTypes.default.string,
  /** Label for the toggle */
  label: validatePropTypeLabel,
  /** Flag dictating the toggle should be rendered smaller */
  small: _propTypes.default.bool,
  /** Flag dictating if the toggle is disabled */
  disabled: _propTypes.default.bool,
  /** Flag dictating the checked state of the toggle */
  checked: _propTypes.default.bool,
  /** Flag dictating the defaultChecked state of the toggle, defaults to false */
  defaultChecked: _propTypes.default.bool,
  /** Flag dictating if the toggle should hide its label*/
  hideLabel: _propTypes.default.bool,
  /** onChange callback */
  onChange: _propTypes.default.func,
  /** onKeyDown override, (default allows Enter and Space to flip the toggle) */
  onKeyDown: _propTypes.default.func,
  /** Identifies the toggle on the page, must be unique if multiple component share the same label (used for aria references) */
  // used for aria references.
  id: _propTypes.default.string,
  /** Developer indicates tabIndex */
  tabIndex: _propTypes.default.oneOf([-1, 0])
};
Toggle.displayName = 'Toggle';
var _default = Toggle;
exports.default = _default;